declare const I18n;

import React, { useState, useEffect } from "react";
import AchievementProgressBar from "../../components/AchievementProgressBar";
import WomenInStemModal from "../../modals/WomenInStemModal";

type WomenInStemCardProps = {
  name: string;
  skillSlug: string;
  info: string;
  isNew: boolean;
  currentPoints: number;
  pointsRequired: number;
  imageUrl: string;
  badgeId?: string;
  learn_more_url?: string;
  unlocked: boolean;
  showProgress?: boolean
  isAdmin?: boolean;
};

const WomenInStemCard: React.FC<WomenInStemCardProps> = ({
  name,
  skillSlug,
  info,
  isNew,
  currentPoints,
  pointsRequired,
  imageUrl,
  unlocked,
  badgeId,
  learnMoreUrl,
  showProgress = false,
  isAdmin = false
}) => {

  const [showModal, setShowModal] = useState(false);

  const [photoUrl, setPhotoUrl] = useState<string>("/blackout.svg");

  useEffect(() => {
    if (!unlocked || !imageUrl) {
      setPhotoUrl("/blackout.svg");
      return;
    }

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => setPhotoUrl(imageUrl);
    img.onerror = () => setPhotoUrl("/blackout.svg");
  }, [imageUrl, unlocked]);


  let percentCompleted = 0

  if (currentPoints && pointsRequired) {
    percentCompleted = Math.floor(currentPoints / pointsRequired * 100)
  }

  if (!unlocked && !pointsRequired) {
    return null
  }

  return (
    <>
      <div className="skill-card-outer">
        <button
          className={`skill-card-button ${unlocked ? "skill-card-button--unlocked": ""}`}
          onClick={(e) => {
            e.stopPropagation();
            if (unlocked) {
              setShowModal(true);
            }
          }}
        >
          <div
            className={`skill-card ${unlocked ? "skill-card--unlocked" : "skill-card--locked"}`}
            style={{ "--skill-photo": `url('${photoUrl}')` } as React.CSSProperties}
          >
            {unlocked ? (
              <>
                <button
                  className="skill-card__info-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                  }}
                >
                  <i className="fa-regular fa-info-circle"></i>
                </button>
                <p className="skill-card__name skill-card-info__unlocked">{name}</p>
              </>
            ) : showProgress ? (
              <div className="skill-card-info__locked">
                <p className="skill-card__name">
                  {I18n.t("models.skills.messaging.points_earned", {
                    points: currentPoints || 0,
                    total: pointsRequired,
                  })}
                </p>
                <AchievementProgressBar progress={percentCompleted} />
                <p className="skill-card__percent_completed">
                  {I18n.t("models.skills.messaging.percent_completed", { percent: percentCompleted })}
                </p>
              </div>
            ) : null}
          </div>
        </button>


        {isAdmin && (
          <a href={`/admin/badges/${badgeId}`} className="edit-profile-link">
            {I18n.t("views.achievements.common.edit_badge")}
          </a>
        )}
      </div>


      <WomenInStemModal
        skillSlug={skillSlug}
        name={name}
        info={info}
        pointsRequired={pointsRequired}
        learnMoreUrl={learnMoreUrl}
        imageUrl={imageUrl}
        isNew={isNew}
        show={showModal}
        closeModal={() => setShowModal(false)}
      />
    </>)
}


export default WomenInStemCard;
